<template>
  <div class="portfoliolist_template">
    <div v-if="currentAssetsdata !== undefined && currentAssetsdata.length" class="comparables_title">
      <div class="comparables_title--text">
        {{ $t("showing") }} <strong>{{ currentAssetsdata.length }}</strong> {{ $t("assets") }}
        <button class="brains-type5-btn ml-2" @click="configList()">{{ $t("configuration") }}</button>
      </div>
    </div>
    <div v-else class="container-comparables-not-selected">
      {{ $t("first-select-upload-portfolio") }}
    </div>
    <div class="hotcontainer" style="width:100%">
      <hot-table ref="hotTablePortfolio" :language="lang" :settings="tablesettings" />
    </div>

    <modal v-model="dialogconfigVisible" class="pf-config-modal">
      <portfolioconfigcolumn ref="colconfig" :portfolioid="portfolioid" />
    </modal>
    <modal v-model="activeModal" class="pf-edit-modal">
      <editAssetDataModalPort v-if="activeModal" :asset-data="assetData" />
    </modal>
  </div>
</template>

<script>
// import textInput from '@/components/designComponents/textInput'
// import { _ } from 'vue-underscore'
import portfolioconfigcolumn from '@/components/designComponents/portfoliocolumnsconfig'
import modal from '@/components/designComponents/modal'
import { separadorMiles } from '@/utils/chartutils'
import { mapState } from 'vuex'
import editAssetDataModalPort from '@/components/designComponents/editPortDataModal.vue'
import 'handsontable/dist/handsontable.full.css'
import { HotTable } from '@handsontable/vue'
import { registerLanguageDictionary, itIT } from 'handsontable/i18n'
// import Handsontable from 'handsontable'
import { registerAllModules } from 'handsontable/registry'
registerAllModules()
registerLanguageDictionary(itIT)
export default {
  name: 'PortfolioList',
  components: { portfolioconfigcolumn, modal, editAssetDataModalPort, HotTable },
  data() {
    return {
      orderedby: 'id',
      // listassets: [],
      // listcolumns: [],
      dialogconfigVisible: false,
      activeModal: false,
      activeModalid: null,
      tablesettings: {
        data: [],
        rowHeaders: false,
        colHeaders: [],
        readOnly: true,
        height: '80vh',
        // width: '100%',
        // stretchH: 'all',
        // autoColumnSize: true,
        // autoWrapRow: false,
        columnSorting: true,
        contextMenu: ['alignment', 'freeze_column', 'unfreeze_column'],
        filters: true,
        dropdownMenu: [
          'filter_by_condition',
          'filter_operators',
          'filter_by_condition2',
          '---------',
          'filter_by_value',
          '---------',
          'filter_action_bar'
        ],
        manualColumnFreeze: true,
        search: true,
        licenseKey: 'non-commercial-and-evaluation' // for non-commercial use only
      }
    }
  },
  computed: {
    ...mapState('portfolio', {
      portfolioid: (state) => state.currentportfolio.id,
      currentselectedasset: (state) => state.currentportfolio,
      matchColumns: (state) => state.currentportfolio.matchColumns,
      tableColumns: (state) => state.currentportfolio.tableColumns,
      currentAssetsdata: (state) => state.currentportfolio.data
    }),
    lang: {
      get() {
        return localStorage.getItem('lang') + '-' + localStorage.getItem('lang').toUpperCase()
      }
    },
    listcolumnsport: {
      get() {
        if (this.tableColumns !== undefined) {
          return this.tableColumns
        } else {
          return []
        }
      }
    },
    listcolumns: function() {
      return Array.from(this.listcolumnsport)
    },
    assetData: function() {
      const vm = this
      return vm.currentAssetsdata.filter(item => { return item.id === vm.activeModalid })[0]
    }
  },
  watch: {
    /*
    currentAssets: function() {
      this.listassets = this.currentAssets
    },
    */
    listcolumnsport: function() {
      // this.listcolumns = Array.from(this.listcolumnsport)
      this.dialogconfigVisible = false
      this.updatetable()
    }
  },
  mounted() {
    this.$root.$on('comparableAssetHoveredOut', () => {
      this.removeOldHovered()
    })

    this.$root.$on('comparableAssetHovered', (idasset) => {
      this.MapHoveredComparable(idasset)
    })

    this.$root.$on('AssetClicked', (idcomparable) => {
      this.manageAssetModal(idcomparable)
    })
  },
  methods: {
    updatetable() {
      const vm = this
      const headers = this.listcolumns.map(item => { return item.clientTitle })
      headers.push('id')
      const columns = this.listcolumns.map(item => { return { data: item.brainsId } })
      columns.push({ data: 'id' })
      this.tablesettings.colHeaders = headers
      this.tablesettings.columns = columns
      this.tablesettings.hiddenColumns = {
        copyPasteEnabled: false,
        indicators: false,
        columns: [columns.length - 1]
      }
      this.tablesettings.afterOnCellMouseDown = function afterOnCellMouseDown(_, coords) {
        if (coords.row > -1) {
          var sourceValue = this.getDataAtCell(coords.row, this.countCols() - 1)
          vm.manageAssetModal(sourceValue)
        }
      }
      this.tablesettings.afterOnCellMouseOver = function afterOnCellMouseOver(_, coords) {
        if (coords.row > -1) {
          var sourceValue = this.getDataAtCell(coords.row, this.countCols() - 1)
          const asset = vm.currentAssetsdata.filter(item => { return item.id === sourceValue })[0]
          vm.showAssetInMap(asset)
        }
      }
      this.tablesettings.afterOnCellMouseOut = function afterOnCellMouseOut(_, coords) {
        if (coords.row > -1) {
          var sourceValue = this.getDataAtCell(coords.row, this.countCols() - 1)
          const asset = vm.currentAssetsdata.filter(item => { return item.id === sourceValue })[0]
          vm.hideAssetInMap(asset)
        }
      }
      this.tablesettings.data = this.currentAssetsdata
      this.$refs.hotTablePortfolio.hotInstance.updateSettings(this.tablesettings)
      // this.$refs.hotTablePortfolio.hotInstance.loadData(this.currentAssetsdata)
      vm.searchplugin = this.$refs.hotTablePortfolio.hotInstance.getPlugin('search')
    },
    /**
     * Se realizan gestiones de la variable que se pinta en la tabla
     * Principalmente enfocado para añadir los decimales y los separadores de miles
     * Coordenadas: max 4 decimales
     * Superficies: max 2 decimales, separador de miles
     * Precios venta: No decimales, separador de miles
     */
    getRowValue(asset, brainsId, clientTitle) {
      // Se llama la función que dice cuantos decimales o si tiene decimales tendrá el dato a devolver mirando por su nombre
      var numDecimales = this.getNumDecimales(clientTitle, brainsId, asset[brainsId])
      var extension = this.getExtension(clientTitle, brainsId)

      // Es string
      if (numDecimales === null) {
        return asset[brainsId]
      } else if (numDecimales === 4) {
        // Principalmente para latitud y longitud
        if (asset[brainsId] !== null) {
          return parseFloat(asset[brainsId]).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: numDecimales })
        }
      } else {
        // Para el resto de valores numeros
        if (asset[brainsId] !== null) {
          // return separadorMiles(asset[brainsId].toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: numDecimales }).replace('.', ','))
          return separadorMiles(parseFloat(asset[brainsId]).toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: numDecimales })) + extension
        }
      }
    },
    getExtension(clientTitle, brainsId) {
      var result = ''

      if (brainsId.includes('Values_')) {
        result = ' €'
      }

      if (brainsId.includes('Values_') &&
      (clientTitle.toLowerCase().includes('time to sale') ||
       clientTitle.toLowerCase().includes('time to rent') ||
       clientTitle.toLowerCase().includes('tts') ||
       clientTitle.toLowerCase().includes('ttr') ||
       clientTitle.toLowerCase().includes('sale time') ||
       clientTitle.toLowerCase().includes('rent time') ||
       clientTitle.toLowerCase().includes('tiempo publicado'))
      ) {
        result = ''
      }

      return result
    },
    getNumDecimales(clientTitle, brainsId) {
      var result = null

      // Primero se comprueba si es location para formatear a 4 decimales
      switch (clientTitle) {
        case 'Location_14':
        case 'Location_15':
        case 'BrainsLatitude':
        case 'BrainsLongitude':
        case 'Latitude':
        case 'Longitude':
          result = 4
          break
        case 'UWREV':
        case 'BrainsAvg_Time_To_Rent':
        case 'BrainsAvg_Time_To_Sale':
          result = 1
          break
        default:
          result = null
          break
      }

      // Luego se revisa si es un Value para formatear bien
      if (
        brainsId.includes('Values_') ||
       clientTitle.includes('Values_') ||
       clientTitle.toLowerCase().includes('time to sale') ||
       clientTitle.toLowerCase().includes('time to rent') ||
       clientTitle.toLowerCase().includes('tts') ||
       clientTitle.toLowerCase().includes('ttr') ||
       clientTitle.toLowerCase().includes('sale time') ||
       clientTitle.toLowerCase().includes('rent time') ||
       clientTitle.toLowerCase().includes('tiempo publicado')) {
        result = 1
      }

      return result
    },
    /**
     * Calculo de la cantidad de decimales que pueda tener un valor
     */
    getNumDecimalesOLD(clientTitle, brainsId, value) {
      var typeValue = typeof value
      var result = null
      var excluded = false

      switch (clientTitle) {
        case 'Location_14':
        case 'Location_15':
        case 'BrainsLatitude':
        case 'BrainsLongitude':
        case 'Latitude':
        case 'Longitude':
          result = 4
          break
        case 'Assetsqm':
        case 'BuiltSqm':
        case 'BrainsAsking_Var_QoQ_Em2':
        case 'BrainsAsking_Var_QoQ_TTS':
        case 'BrainsAsking_rent_Var_QoQ_Em2_month':
        case 'BrainsEm2_Asking':
        case 'BrainsEm2_Transaction':
        case 'BrainsEm2_month_asking_rent':
        case 'BrainsMarket_Recovery':
        case 'BrainsTransactions_Var_QoQ_Em2':
          result = 2
          break
        case 'UWREV':
        case 'BrainsAvg_Time_To_Rent':
        case 'BrainsAvg_Time_To_Sale':
          result = 1
          break
        case 'AppraisalE':
        case 'ID_Order':
        case '212201':
        case 'id':
          result = 0
          break
        case 'ZipCode':
        case 'CadastralReference':
        case 'BrainsParcelaRefCat':
        case 'BrainsCensusDistrict':
        case 'BrainsCensusDistrictCode':
        case 'BrainsCensus':
        case 'Census':
        case 'CensusDistrict':
        case 'CensusDistrictCode':
          excluded = true
          result = null
          break
        default:
          result = null
          break
      }

      // Comprobamos que el resultado sea null (no esta en el switch) y que la columna no este excluida por ser un numero
      // de referencia que no necesita decimales o separadores de miles
      if (result === null && !excluded) {
        // Primero miramos si es un numero directamente, si es asi, directamente vemos si es menor de 1500, que en tal caso tendrá un decimal
        // Si es mayor, tendrá 0
        if (typeValue === 'number' && value < 1500) {
          result = 1
        } else if (typeValue === 'number' && value >= 1500) {
          result = 0
        }

        // En caso de que el valor sea un string pero después del formateo vemos que no tiene ninguna letra y es un numero al parsear
        // se mira el tamaño igual que antes
        if (typeValue === 'string' && /^\d+$/.test(value) && !isNaN(parseFloat(value)) && parseFloat(value) < 1500) {
          result = 1
        } else if (typeValue === 'string' && /^\d+$/.test(value) && !isNaN(parseFloat(value)) && parseFloat(value) >= 1500) {
          result = 0
        }
      }

      if (brainsId.includes('Values_')) {
        result = 1
      }

      return result
    },
    handleOpen() {
      const vm = this
      this.$nextTick(() => {
        vm.$refs.colconfig.loadtable(
          [
            ...new Set(
              vm.currentAssetsdata.flatMap((item) => {
                return Object.keys(item)
              })
            )
          ].map((item) => {
            if (item.startsWith('Brains')) {
              return {
                prop: item,
                label: item,
                useintable: false,
                useinstrats: false,
                useinfilters: false
              }
            }
            var matchId = vm.matchColumns.find(f => f.brainsId === item)
            return {
              prop: item,
              label: matchId ? matchId.clientTitle : item,
              useintable: false,
              useinstrats: false,
              useinfilters: false
            }
          })
        )
      })
    },
    configList() {
      this.handleOpen()
      this.dialogconfigVisible = true
    },
    showAssetInMap(asset) {
      this.$root.$emit('ShowAssetInMap', {
        geometry: { longitude: asset.BrainsLongitude, latitude: asset.BrainsLatitude },
        attributes: { id_portfolio: asset.id }
      }, true)
    },
    hideAssetInMap(asset) {
      this.$root.$emit('ShowAssetInMap', {
        geometry: { longitude: asset.BrainsLongitude, latitude: asset.BrainsLatitude },
        attributes: { id_portfolio: asset.id }
      }, false)
    },
    clickAssetInmap(asset) {
      this.manageAssetModal(asset.id)
    },
    manageAssetModal(idasset) {
      this.activeModalid = idasset
      this.activeModal = true
    },
    removeOldHovered() {
      this.$refs.hotTablePortfolio.hotInstance.deselectCell()
    },
    MapHoveredComparable(idcomparable) {
      const vm = this
      const queryResult = vm.searchplugin.query(idcomparable + '').filter(item => { return item.col === vm.listcolumns.length })
      if (queryResult.length > 0) {
        this.$refs.hotTablePortfolio.hotInstance.selectCell(queryResult[0].row, 0, queryResult[0].row, 0)
      }
    }
  }
}
</script>
<style lang="scss">
.pf-config-modal .brains-asset-data-modal--content {
  width: 500px !important;
}

.pf-edit-modal .brains-asset-data-modal--content {
  height: 80vh!important;
  margin-top: 10vh;
  width: 80% !important;
}

.selectedrow {
  font-weight: bold;
  // border: 1px solid grey;
  box-sizing: border-box;
}
.normalrow {
  background-color: #fff;
  margin-bottom: 2px;
  padding-top: 2px;
  box-sizing: border-box;
}

.comparables_title {
  color: black;
  padding: 7px 10px;
  font-size: 16px;
  display: flex;
  height: 47px;
  align-items: center;
  justify-content: space-between;

  &--text {
    font-size: 14px;
    padding-left: 15px;

    strong {
      font-weight: 600;
    }
  }

  &--input-search {
    width: 100%;
    max-width: 350px;
    display: flex;
    justify-content: flex-end;
  }
}

.comparablelist {
  height: calc(100vh - 190px);
  overflow: auto;
  width: 100%;
  // overflow-x: hidden;
  overflow-x: scroll;
}

.portfoliolist_template table {
  width: 100%;
  font-size: 12px !important;
  // border-spacing: 0;
  // border-collapse: separate;

  thead {
    th {
      position: sticky;
      padding: 4px;
      top: 0;
      // color: #1e3cff;
      color: #333333;
      background-color: white;
      font-family: "Montserrat-SemiBold",sans-serif;
      font-size: 14px;
      z-index: 999;
      border-bottom: 2px solid #1e3cff;
    }

    &:hover {
      cursor: pointer;
    }
  }

  tbody {
    tr {
      height: 25px;
      text-align: center;
      cursor: pointer;
    }
    td {
      // height: 25px;
      // border-bottom: none;
    }
  }

  .comparables_adress {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 130px;

    a {
      text-decoration: underline !important;
    }
  }
}
.comparable-hovered-map {
  background-color: rgb(43, 163, 158) !important;
  color: #333333;
  font-family: "Montserrat-SemiBold",sans-serif;
}

.portfolio-list-body {
  tr {
    &:hover {
      background-color: rgb(43, 163, 158);
    }

    td {
      vertical-align: middle;
      white-space: nowrap;
    }
  }

  &--td-value {
    display: inline-flex;
    padding: 0 5px 0 5px;
  }
}

.portfolio-header-list-container {
  display: inline-flex;
  gap: 5px;
  padding: 0 5px 0 5px;
}
</style>
